<template>
  <div class="qrcode-wrapper">

    <!-- 二维码 -->
    <div class="qrcode-box">
      <qrcode-vue class="qrcode" :value="targetLink" :size='126'/>
    </div>

    <!-- 描述 -->
    <h4>扫码拍摄并上传照片</h4>
    <p>手机上传照片时请不要关闭此弹窗</p>

    <!-- 按钮 -->
    <div class="qrcode-btn-box">
      <div class="qrcode-btn back" @click="goBackFunc()">返回</div>
      <div class="qrcode-btn confirm" v-if="btnVisible" @click="debounce(() => { checkUserUploadFunc() }, 300)">我已上传完成</div>
    </div>

  </div>
</template>

<script>
import api from '@/api'
import QrcodeVue from 'qrcode-vue'

import { uuid } from 'vue-uuid'
import { componentsMixin } from '@/assets/js/mixins/components'

export default {
  data () {
    return {
      photoId: null, // 唯一 id 用于存图片
      btnVisible: false, // 控制按钮显示和隐藏
      timer: null,
      host: null
    }
  },
  mixins: [ componentsMixin ],
  components: {
    QrcodeVue
  },
  created () {
    this.photoId = uuid.v1()
    this.host = window.location.origin.replace("www", "m")
    // this.host = 'https://m.wondercv.cn'
  },
  mounted () {
    this.timer = setTimeout(() => {
      clearTimeout(this.timer)
      this.btnVisible = true
    }, 5000)
  },
  computed: {
    targetLink () {
      return `${this.host}/transfer-station/upload-portrait/index?photoId=${this.photoId}&isPc=true`
    }
  },
  methods: {
    // 检查用户是否上传成功
    async checkUserUploadFunc () {
      try {
        let params = this.photoId
        let res = await api.portrait.getUserUploadPhoto(params)
        if (res.code === 1000) {
          if (res.data.status === 'success') {
            this.$message.success('上传成功')
            this.$emit('uploaded', res.data.url)
          } else {
            this.$message.error('未检测到图片，请尝试重新上传！')
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 返回上一步
    goBackFunc () {
      this.$emit('goBackFunc')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./index.scss";
</style>
